import Box from "@mui/material/Box";
import { Link as RouterLink } from "react-router-dom";
import { tokens } from "../theme";

export default function Wordmark({ size = 26 }: { size?: number }) {
  return (
    <Box
      component={RouterLink}
      to="/"
      aria-label="TLArt home"
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        gap: "0.06em",
        textDecoration: "none",
        color: tokens.ink,
        fontFamily: tokens.display,
        fontWeight: 500,
        fontSize: size,
        lineHeight: 1,
        letterSpacing: "0.02em",
        userSelect: "none",
      }}
    >
      <Box component="span">TL</Box>
      <Box component="span" sx={{ fontStyle: "italic", fontWeight: 400, color: tokens.taupe }}>
        art
      </Box>
      <Box
        component="span"
        sx={{ width: size * 0.13, height: size * 0.13, mb: `${size * 0.08}px`, ml: "0.12em", borderRadius: "50%", bgcolor: tokens.brass }}
      />
    </Box>
  );
}
